export enum EFeatures {
  CONTENT = 'CONTENT',
  QUIZZES = 'QUIZZES',
  LIVE_CLASSES = 'LIVE_CLASSES',
  TUTORING = 'TUTORING',
  ANNOUNCEMENTS = 'ANNOUNCEMENTS',
  EXAMS_SCORES = 'EXAMS_SCORES',
  PLANIFICATION = 'PLANIFICATION'
}
